// root level standalone paths
export const LANDING_PATH = '/';
export const ABOUT_US_PATH = '/about-us';
export const FAQ_PATH = '/faq';
export const LOGIN_PATH = '/login';
export const PRIVACY_POLICY_PATH = '/privacy-policy';
export const RESTAURANT_DEMO_PATH = '/demos';
export const RESTAURANTS_PATH = '/dir';
export const TERMS_OF_SERVICE_PATH = '/terms-of-service';
export const REDIRECT_PATH = 'redirect';

// account paths
export const ACCOUNT_ROOT_PATH = '/account';
export const ACCOUNT_NOTIFICATIONS_PATH = '/account/notifications';
export const ACCOUNT_BALANCE_PATH = '/account/balance';
export const ACCOUNT_EMAIL_PATH = '/account/email';
export const ACCOUNT_PAYMENT_METHODS_PATH = '/account/payment-methods';

// plaid paths
export const PLAID_ROOT_PATH = 'plaid';
export const PLAID_AUTH_PATH = '/plaid/auth';
export const PLAID_AUTH_TERMINAL_PATH = 'auth';

// checkout paths
export const CHECKOUT_ROOT_PATH = 'checkout';
export const CHECKOUT_CONFIRMATION_TERMINAL_PATH = 'confirmation';

// email verification paths
export const EMAIL_VERIFICATION_FAIL_PATH = '/email-verification/fail';
export const EMAIL_VERIFICATION_SUCCESS_PATH = '/email-verification/success';

// restaurant paths
export const RESTAURANT_ROOT_PATH = '/:locationSlug/:nameSlug';
export const OLD_RESTAURANT_ROOT_PATH = `/old${RESTAURANT_ROOT_PATH}`;
export const NEW_GUEST_LANDING_RESERVE_PATH = 'reserve';
export const NEW_GUEST_LANDING_OFFER_PATH = 'offers/:offerId';
export const NEW_GUEST_LANDING_MODIFY_PATH = ':reservationId';
export const NEW_GUEST_LANDING_MODIFY_RESERVE_PATH = ':reservationId/reserve';

// event paths
export const EVENT_PAGE_PATH = 'events';
// The date is optional: events created before name-only URLs keep their `slug/date` URL.
export const EVENT_TICKET_PURCHASE_PATH = `${EVENT_PAGE_PATH}/:eventNameSlug/:eventDate?`;

// offers paths
export const OFFERS_ROOT_PATH = '/offers';
export const OFFERS_IN_PATH = '/offers/in';
export const OFFERS_OUT_PATH = '/offers/out';

// offer checkout paths
export const OFFER_EDIT_PATH = 'edit';
export const OFFER_UPDATE_ROOT_PATH = `/offers${RESTAURANT_ROOT_PATH}/:offerId/${OFFER_EDIT_PATH}`;
export const OFFER_CHECKOUT_PATH = 'offer-checkout';
export const OFFER_CHECKOUT_CONFIRMATION_TERMINAL_PATH = 'offer-confirmation';

// offer details path (not using the same layout as above)
export const OFFER_OUT_DETAILS_PATH = `/offers${RESTAURANT_ROOT_PATH}/:offerId`;

// reservations paths
export const RESERVATIONS_ROOT_PATH = '/reservations';
export const RESERVATIONS_CONFIRMED_PATH = '/reservations/confirmed';
export const RESERVATIONS_INACTIVE_PATH = '/reservations/inactive';
export const RESERVATION_DETAILS_PATH = `/reservations${RESTAURANT_ROOT_PATH}/:reservationId`;
export const OLD_RESERVATION_DETAILS_PATH = `/old/reservations${RESTAURANT_ROOT_PATH}/:reservationId`;
export const RESERVATION_EDIT_PATH = 'edit';
export const PAY_LINK_PATH = '/p/:reservationId';

// hiring path
export const HIRING_PATH = 'https://jobs.ashbyhq.com/peak-reservations';
